import React, { useEffect, useRef, useState } from 'react';
import Lottie from 'lottie-react';

// Load Lottie animations dynamically
const loadAnimation = async (path: string) => {
    const response = await fetch(path);
    return response.json();
};

/**
 * Premium Lottie animations for Quick Action cards
 * Using Lottie JSON files for smooth animations
 */

// Tools Icon - Phone flow 3D animation
export const ToolsIcon: React.FC<{ className?: string }> = ({ className = '' }) => {
    const [animationData, setAnimationData] = useState<any>(null);
    const lottieRef = useRef<any>(null);

    useEffect(() => {
        loadAnimation('/images/Phone flow 3D.json').then(setAnimationData);
    }, []);

    useEffect(() => {
        if (lottieRef.current && animationData) {
            lottieRef.current.setSpeed(1);
            lottieRef.current.play();
        }
    }, [animationData]);

    if (!animationData) {
        return <div className={className} style={{ width: '100%', height: '100%' }} />;
    }

    return (
        <div className={className} style={{ width: '100%', height: '100%' }}>
            <Lottie
                lottieRef={lottieRef}
                animationData={animationData}
                loop={true}
                autoplay={true}
                style={{ width: '100%', height: '100%' }}
            />
        </div>
    );
};

// Keys Icon - Cybersecurity animation
export const KeysIcon: React.FC<{ className?: string }> = ({ className = '' }) => {
    const [animationData, setAnimationData] = useState<any>(null);
    const lottieRef = useRef<any>(null);

    useEffect(() => {
        loadAnimation('/images/Cybersecurity.json').then(setAnimationData);
    }, []);

    useEffect(() => {
        if (lottieRef.current && animationData) {
            lottieRef.current.setSpeed(1);
            lottieRef.current.play();
        }
    }, [animationData]);

    if (!animationData) {
        return <div className={className} style={{ width: '100%', height: '100%' }} />;
    }

    return (
        <div className={className} style={{ width: '100%', height: '100%' }}>
            <Lottie
                lottieRef={lottieRef}
                animationData={animationData}
                loop={true}
                autoplay={true}
                style={{ width: '100%', height: '100%' }}
            />
        </div>
    );
};

// Views Icon - Youtube animation
export const ViewsIcon: React.FC<{ className?: string }> = ({ className = '' }) => {
    const [animationData, setAnimationData] = useState<any>(null);
    const lottieRef = useRef<any>(null);

    useEffect(() => {
        loadAnimation('/images/Youtube.json').then(setAnimationData);
    }, []);

    useEffect(() => {
        if (lottieRef.current && animationData) {
            lottieRef.current.setSpeed(1);
            lottieRef.current.play();
        }
    }, [animationData]);

    if (!animationData) {
        return <div className={className} style={{ width: '100%', height: '100%' }} />;
    }

    return (
        <div className={className} style={{ width: '100%', height: '100%' }}>
            <Lottie
                lottieRef={lottieRef}
                animationData={animationData}
                loop={true}
                autoplay={true}
                style={{ width: '100%', height: '100%' }}
            />
        </div>
    );
};

// Community Icon - Social network animation
export const CommunityIcon: React.FC<{ className?: string }> = ({ className = '' }) => {
    const [animationData, setAnimationData] = useState<any>(null);
    const lottieRef = useRef<any>(null);

    useEffect(() => {
        loadAnimation('/images/Social network.json').then(setAnimationData);
    }, []);

    useEffect(() => {
        if (lottieRef.current && animationData) {
            lottieRef.current.setSpeed(1);
            lottieRef.current.play();
        }
    }, [animationData]);

    if (!animationData) {
        return <div className={className} style={{ width: '100%', height: '100%' }} />;
    }

    return (
        <div className={className} style={{ width: '100%', height: '100%' }}>
            <Lottie
                lottieRef={lottieRef}
                animationData={animationData}
                loop={true}
                autoplay={true}
                style={{ width: '100%', height: '100%' }}
            />
        </div>
    );
};
